import { render, staticRenderFns } from "./bimCol.vue?vue&type=template&id=09aa3a1f&scoped=true&"
import script from "./bimCol.vue?vue&type=script&lang=js&"
export * from "./bimCol.vue?vue&type=script&lang=js&"
import style0 from "./bimCol.vue?vue&type=style&index=0&id=09aa3a1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aa3a1f",
  null
  
)

export default component.exports